import { Tabs } from '@mantine/core'
import { useLocation, useNavigate } from 'react-router-dom'

const items = [
  { label: 'Organizations', value: '/super/organizations' },
  { label: 'Terminology', value: '/super/terminology' },
  { label: 'Reminders', value: '/super/reminders' },
  { label: 'Consents & Contracts', value: '/super/consents-contracts' },
  { label: 'Provider Enroll', value: '/super/provider-enroll' },
  { label: 'Call Center Agents', value: '/super/call-center-agents' },
  { label: 'Data Migrations', value: '/super/data-migrations' },
  { label: 'Test Catalog', value: '/super/test-catalog' },
  { label: 'Tasks', value: '/super/tasks' },
  { label: 'CPG', value: '/super/cpg' },
  { label: 'Auth', value: '/super/auth' },
  { label: 'Integrations', value: '/super/integrations' },
  { label: 'Persona pilot', value: '/super/persona-pilot' },
  { label: 'Merged patients', value: '/super/merged-patients' },
]

export function Navigation() {
  const location = useLocation()
  const navigate = useNavigate()

  // Exact match first; otherwise a sub-path ('/super/cpg/review') highlights its tab.
  const active =
    items.find((item) => location.pathname === item.value)?.value ??
    items.find((item) => location.pathname.startsWith(`${item.value}/`))?.value ??
    location.pathname

  return (
    <Tabs
      variant="outline"
      defaultValue={active}
      className="sticky top-16 z-11 bg-white"
      classNames={{
        list: '!bg-primary',
        tab: 'data-[active=true]:!bg-white aria-[selected=false]:!text-white aria-[selected=false]:hover:!opacity-80',
      }}
    >
      <Tabs.List>
        {items.map((item) => (
          <Tabs.Tab value={item.value} key={item.value} onClick={() => navigate(item.value)}>
            {item.label}
          </Tabs.Tab>
        ))}
      </Tabs.List>
    </Tabs>
  )
}
